export const APP_RUNTIME_CONFIG = {
    cahchePrefix: 'flugboerse',
    isFlugb: true,
    ports: {
        socket: 3340,
        backoffice: 3345,
        poster: 3349,
        zoom: 3346,
        media: 3347,
        app: 3342,
        appuniv: 3341,
    }
};
